define(
    'viewmodels/secured/help/guided/addPeople',[
        "viewmodels/ViewModel",
        "plugins/router",
        "helper/textParser",
        "services/session",
        "i19n!i19n/strings",
    ],
    function (ViewModel, router, textParser, session, i19n) {

        var vm = new ViewModel({
            i19n: i19n,
            id: '2',
            descriptions: ko.observableArray([]),
            todos: ko.observableArray([]),
            tip: ko.observable('')
        });

        vm.activate = function () {
            //text | href | target

            if (vm.descriptions().length == 0) {
                vm.descriptions.push("Everyone who needs to access documents must be setup as a Person in fileplan. ");
                vm.descriptions.push("The minimum information you will need to add each person is: <ul><li>first & last names</li> <li>email address</li> <li>role</li> <ul>");
                vm.descriptions.push("Each user will receive an email invitation to set their own password. ");
            }
            if (vm.todos().length == 0) {
                vm.todos.push({ icon: 'fa-video-camera', isDone: false, html: textParser.toHtml('Watch the {Working with People | http://www.fileplan.com/working-with-people-video | _blank} video.') });
                vm.todos.push({ icon: 'fa-book', isDone: false, html: textParser.toHtml('Read the {Adding a Person | http://help.fileplan.com/hc/en-us/articles/203110424-Adding-a-Person | _blank} article.') });
                vm.todos.push({ icon: 'fa-book', isDone: false, html: textParser.toHtml('Read the {User Roles | http://help.fileplan.com/hc/en-us/articles/203110414-User-Roles | _blank} article  to learn about the different levels of access available in fileplan. ') });
                vm.todos.push({ icon: 'fa-hand-pointer-o', isDone: false, html: textParser.toHtml('On the {People page | #people | _blank}, click the "Add Person" button to invite new users to fileplan.') });
            }
            vm.tip(textParser.toHtml("If you have 5 or more users, assigning People to Teams will help you administer fileplan effectively. Learn more about {Teams and Team Membership | http://help.fileplan.com/hc/en-us/articles/203110434-Teams-and-Team-Membership | _blank}."));
        };
        vm.attached = function () {
            $(".a-route").unbind("click");
            $(".a-route").bind("click", function (e) {
                router.navigate($(this).attr("href"));

                return false;
            });
        };

        return vm;
    }
);
